// extracted by mini-css-extract-plugin
module.exports = {"content":"InstructorApproverDetails_content__2WhSv","grid":"InstructorApproverDetails_grid__26v2c","fullWidth":"InstructorApproverDetails_fullWidth__3eE0T"};